export default "__VITE_ASSET__7c0db008__"